import {useState} from 'react'
import Image from 'next/future/image'
import {LoaderButton} from '@skyslope/mache'

import {useRouter} from '~/hooks'
import {cs} from '~/utils'
import {NoGradientLayout, NoGradientLayoutProps} from '../layout'

export type ThisListingIsNotReadyYetPageProps = NoGradientLayoutProps & {}

/**
 * A page to indicate that the listing that the user is trying to
 * submit an offer on isn't ready to accept offers yet.
 */
export function ThisListingIsNotReadyYetPage(props: ThisListingIsNotReadyYetPageProps) {
  const {className, classes, ...rest} = props
  const {router} = useRouter()
  const [showSpinner, setShowSpinner] = useState(false)

  return (
    <NoGradientLayout
      {...rest}
      classes={{
        root: cs('ThisListingIsNotReadyYetPage', 'h-full flex flex-col', classes?.root, className),
        childWrapper: cs(
          'flex flex-1 flex-col justify-center text-left p-4 pb-28',
          classes?.childWrapper,
        ),
      }}
    >
      <Image
        src="/static/images/link-expired/dog-disconnected.svg"
        width={961}
        height={289}
        alt=""
        className="mx-auto"
      />

      <div className="flex justify-center">
        <div className="flex max-w-lg flex-col text-center">
          <p className="my-4 text-2xl text-grey-900">
            This listing is almost ready to accept offers.
          </p>
          <p className="mb-8 px-7 text-lg text-grey-800">
            We&apos;re working to get this listing ready for offers. This can take anywhere from
            five to twenty minutes. Please try again soon.
          </p>

          <LoaderButton
            className="mx-auto w-32"
            variant="contained"
            isLoading={showSpinner}
            onClick={() => {
              setShowSpinner(true)
              router.reload()
            }}
          >
            Refresh
          </LoaderButton>
        </div>
      </div>
    </NoGradientLayout>
  )
}
